var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-5"},[_c('v-card-title',[_vm._v(" Administrer les offres ")]),_c('div',{staticClass:"d-flex flex-row flex-wrap mt-6 justify-center"},_vm._l((_vm.offresAbonnement),function(offre,index){return _c('div',{key:index,staticClass:"mx-5 pb-5"},[_c('OffreAbonnement',{attrs:{"offre":offre}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }